import { useState, useEffect } from 'react';

import { useGetSnapTrapColumns } from '../useGetSnapTrapColumns';

import STRExpandable from './SRSTExpandable';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import TrapDeleteModal from 'components/DeleteTrapModal/TrapsDeleteModal';
import ManageTrapModal from 'pages/Traps/Modals/AddTrapModal/ManageTrapModal';
import EditTrapModal from 'pages/Traps/Modals/EditTrapModalStore/EditTrapModal';
import { SmartSnapTrapData } from 'api/traps/STTraps/types';
import useGetSSTraps from 'hooks/Traps/useGetSSTraps';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface TableProps {
  slug: string;
}

const STRTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetSSTraps(slug || '', 'srst');
  const columns = useGetSnapTrapColumns(slug, TrapTableTypeLink.SnapTrapRat);
  const { isNotDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <FilterDataTable<SmartSnapTrapData>
        columns={columns}
        data={data || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        expandableRowsComponent={row => <STRExpandable data={row.data} slug={slug} />}
      />
      <TrapDeleteModal refetchTraps={refetch} />
      <ManageTrapModal refetchTraps={refetch} />
      <EditTrapModal refetchTraps={refetch} />
    </div>
  );
};

export default STRTable;
